import type { NavSectionProps } from 'src/components/nav-section';

import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

// Ícones do set offline curado (components/iconify/icon-sets.ts). Só valem os
// nomes registrados lá — o tipo IconifyName barra qualquer outro em tempo de
// compilação. Para usar um ícone novo, adicione-o ao icon-sets.
const icon = (name: React.ComponentProps<typeof Iconify>['icon']) => <Iconify icon={name} />;

const ICONS = {
  inicio: icon('solar:home-angle-bold-duotone'),
  nfse: icon('solar:bill-list-bold-duotone'),
  tomados: icon('solar:inbox-in-bold-duotone'),
  guias: icon('solar:wad-of-money-bold'),
  protocolo: icon('solar:notebook-bold-duotone'),
  parcelamento: icon('solar:calendar-date-bold'),
  notificacoes: icon('solar:bell-bing-bold-duotone'),
};

// ----------------------------------------------------------------------

// navData = menu REAL do Portal do Contribuinte do Simples Nacional (Maker sys=NFS),
// levantado ao vivo via Visita Fiscal. Ver docs/portal-contribuinte-migracao/
// MAPA-PORTAL-SN-REAL.md e SPEC-PORTAL-SN-TOMADOR-PF.md.
//
// O menu do portal varia por tipo de contribuinte: TOMADOR PF tem "Serviços
// Tomados - PF"; CONTRIBUINTE EXTERNO (PJ) troca esse item pelo submenu
// "Contribuinte Externo" (escrituração de ISS). Aqui os dois estão listados em
// seções separadas; a gate por tipo/enquadramento vem numa etapa posterior.
//
// PORTE AUDITORIA (Ipatinga): o portal overlay só mostra os módulos portados p/ a
// base da auditoria. Fora do menu (Sandro): EMISSÃO (NFSA-e é só Consulta agora) e
// os GAP de domínio que a auditoria não tem — Meio Ambiente, Plantão Fiscal, Meu
// Imóvel — além de Contribuinte Externo/Sub-usuários (escrituração, não portada).
export const navData: NavSectionProps['data'] = [
  {
    subheader: 'Portal do Contribuinte',
    items: [
      { title: 'Início', path: '/', icon: ICONS.inicio },
      // NFS-e = Consulta de notas emitidas (o portal não emite — sistema overlay).
      { title: 'NFS-e', path: '/nfse', icon: ICONS.nfse },
      // DTE (Fase 3): notificações que o fisco envia ao contribuinte + ciência.
      { title: 'Notificações', path: '/notificacoes', icon: ICONS.notificacoes },
      { title: 'Serviços Tomados', path: '/servicos-tomados', icon: ICONS.tomados },
      { title: 'Guias', path: '/guias', icon: ICONS.guias },
      { title: 'Protocolo', path: '/protocolo', icon: ICONS.protocolo },
      { title: 'Parcelamento', path: '/parcelamento', icon: ICONS.parcelamento },
      // O acesso ao "Meu Perfil" fica no ícone do usuário no cabeçalho.
    ],
  },
];

// Gate por tipo de contribuinte: no overlay da auditoria, Serviços Tomados vale p/
// PF e PJ (a seção Externo/escrituração foi retirada), então não há mais nada a
// esconder por tipo — retorna o menu como está.
export function filterNavByTipo(
  data: NavSectionProps['data'],
  _isPj: boolean | undefined,
): NavSectionProps['data'] {
  return data;
}
